import { Validator } from "vee-validate";

//Classe para simplificar e centralizar a formatação de dinheirinhos
class GeneralMoney {
    constructor() {
        this.currency = "R$";
    }
    get_currency() {
        return this.currency;
    }

    set_currency(currency) {
        this.currency = currency;
    }

    format(money, decimals = 2, separator_decimal = ',') {
        return parseFloat(money).toFixed(decimals).replace(".", separator_decimal);
    }

    formatWithCurrency(money, decimals = 2, separator_decimal = ',') {
        return this.get_currency() + " " + this.format(money, decimals, separator_decimal)
    }
}

//class GeneralValidates{

/**
 * validacao do CPF
 * @todo validar também digitos fixos de 1 a 9
 * @param {} strCPF 
 */

function valida_cpf(strCPF) {
    let _strCPF = strCPF.replace('.','').replace("-","");
    return new Promise(resolve => {
        var Soma;
        var Resto;
        Soma = 0;
        if (_strCPF == "00000000000" ||
            _strCPF == "11111111111" ||
            _strCPF == "22222222222" ||
            _strCPF == "33333333333" ||
            _strCPF == "44444444444" ||
            _strCPF == "55555555555" ||
            _strCPF == "66666666666" ||
            _strCPF == "77777777777" ||
            _strCPF == "88888888888" ||
            _strCPF == "99999999999") {
            return resolve({
                valid: false,
                data: {
                    message: `${_strCPF} é um CPF inválido`
                }
            });
        }
        strCPF = strCPF.replace(/\./g,'').replace('-','');
        for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

        

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10))) {
           
            return resolve({
                valid: false,
                data: {
                    message: `${_strCPF} é um CPF inválido`
                }
            });
        }

        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11))) {
            
            return resolve({
                valid: false,
                data: {
                    message: `${_strCPF} é um CPF inválido`
                }
            });
        }

        return resolve({
            valid: true
        });

    })

}

Validator.extend("cpfcheck", {
    validate: valida_cpf,
    getMessage: (field, params, data) => data.message
});



//}

export { GeneralMoney as money, valida_cpf }
